// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation SupplierArchiveModalMutation($id: ID!)  {\narchiveSupplier(id: $id)  {\n__typename  \nid  \narchivedAt  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.archiveSupplier;
  let value$2 = value$1.archivedAt;
  return {
    archiveSupplier: {
      __typename: value$1.__typename,
      id: value$1.id,
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.archiveSupplier;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let archiveSupplier = {
    __typename: value$4,
    id: value$3,
    archivedAt: archivedAt
  };
  return {
    archiveSupplier: archiveSupplier
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let ArchiveSupplierMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ArchiveSupplierMutation_useWithVariables = include.useWithVariables;

let ArchiveSupplierMutation = {
  ArchiveSupplierMutation_inner: ArchiveSupplierMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithVariables: ArchiveSupplierMutation_useWithVariables
};

let text = "Once the supplier is archived, it will only be visible in the supplier list by applying the \"Archive\" filter.";

function SupplierArchiveModal(props) {
  let supplierBaseRoute = props.supplierBaseRoute;
  let id = props.id;
  let navigate = Navigation.useNavigate();
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let archiveSupplier = match[0];
  let commit = param => {
    Future.tapOk(ApolloHelpers.mutationPromiseToFutureResult(archiveSupplier(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id
    })), param => navigate(undefined, supplierBaseRoute));
  };
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t(text),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: I18n.t("Confirm the archiving of this supplier"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonText: I18n.t("Confirm"),
    commitButtonCallback: commit,
    onRequestClose: props.onRequestClose
  });
}

let make = React.memo(SupplierArchiveModal);

export {
  ArchiveSupplierMutation,
  text,
  make,
}
/* query Not a pure module */
